import { render } from "./DumplingBody.vue?vue&type=template&id=1cdd62a3&scoped=true"
import script from "./DumplingBody.vue?vue&type=script&lang=js"
export * from "./DumplingBody.vue?vue&type=script&lang=js"

import "./DumplingBody.vue?vue&type=style&index=0&id=1cdd62a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cdd62a3"]])

export default __exports__